module.exports = __webpack_public_path__ + "img/Progress-Report-Process-1-mobile.9f9aad19.png";